import React from "react"
import { LocalizedCompetition } from "../../../../types/competition"
import * as ImageConstants from "../../../../constants/images"
import { CountryImageName } from "@components/Country/CountryImageName"
import { LocalizedTeam } from "../../../../types/team"
import Link from "next/link"
import { getCompetitionPageUrl, getTeamPageUrl } from "../../../../utils/urls"
import { Row, Col } from "react-bootstrap"
import style from "./style.module.scss"
import Image from "next/image"
import cx from "classnames"

export function CompetitionDetails({ competition }: { competition: LocalizedCompetition & { teamNumber: number } }) {
  let winnerTeam: LocalizedTeam | undefined | null = undefined
  if (competition.competitionSeasons && competition.competitionSeasons[0].winnerTeam) {
    winnerTeam = competition.competitionSeasons[0].winnerTeam
  }

  return (
    <div className={style.competitionDetailsMainContainer}>
      <Row className={style.card}>
        <Col className={style.imgContainer} xs={3} sm={3} md={2} lg={2} xl={2}>
          <Link passHref href={getCompetitionPageUrl(competition.calciocomSlug!)}>
            <a title={competition.name}>
              <Image
                src={competition.image?.path || ImageConstants.COMPETITION_MISSING_IMAGE_PATH}
                alt={competition.name}
                width={145}
                height={145}
              />
            </a>
          </Link>
        </Col>
        <Col className={style.csName} xs={12} sm={12} md={4} lg={4} xl={4}>
          <h1>{competition.name}</h1>
        </Col>
        <Col className={style.csInfo} xs={9} sm={9} md={6} lg={6} xl={6}>
          <Row className={cx(style.infoRow, style.mobileName)}>
            <Col className={style.label} xs={12} sm={12} md={6} lg={6} xl={6}>
              <h1>{competition.name}</h1>
            </Col>
          </Row>
          {competition.country && (
            <Row className={style.infoRow}>
              <Col className={style.label} xs={6} sm={6} md={6} lg={6} xl={6}>
                Stato
              </Col>
              <Col className={style.value} xs={6} sm={6} md={6} lg={6} xl={6}>
                <CountryImageName country={competition.country} />
              </Col>
            </Row>
          )}
          <Row className={style.infoRow}>
            <Col className={style.label} xs={6} sm={6} md={6} lg={6} xl={6}>
              Numero squadre
            </Col>
            <Col className={style.value} xs={6} sm={6} md={6} lg={6} xl={6}>
              {competition.teamNumber}
            </Col>
          </Row>
          {winnerTeam?.completeName && (
            <Row className={style.infoRow}>
              <Col className={style.label} xs={6} sm={6} md={6} lg={6} xl={6}>
                Campione in carica
              </Col>
              <Col className={style.value} xs={6} sm={6} md={6} lg={6} xl={6}>
                <Link href={getTeamPageUrl(winnerTeam.calciocomSlug!)}>
                  <a title={winnerTeam.completeName}>{winnerTeam.completeName}</a>
                </Link>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </div>
  )
}
